import { api } from './api';

/**
 * "How empathy calls work" — the first-call norms (COHORT-COMMUNICATION.md X2).
 * Backend: App\Services\EmpathyNorms + EmpathyNormsController. The COPY is served:
 * the modal renders what the server sends, so the text a user accepts is the text
 * the recorded version names.
 */
export interface EmpathyNormsCopy {
  title: string;
  lines: string[];
  acknowledge: string;
  learn_more: string;
}

export interface EmpathyNormsStatus {
  required: boolean;
  intro_completed: boolean;
  accepted_version: number | null;
  accepted_at: string | null;
  current_version: number;
  copy: EmpathyNormsCopy;
  /** The next intro lesson for "Learn more in the intro"; null → the course page. */
  learn_more_lesson_id: number | null;
}

export const getEmpathyNorms = async (): Promise<EmpathyNormsStatus> => {
  const response = await api.get<EmpathyNormsStatus>('/me/empathy-norms');
  return response.data;
};

export const acceptEmpathyNorms = async (): Promise<void> => {
  await api.post('/me/empathy-norms/accept');
};
